// @flow

import qs from 'qs';
import Api from './ApiBase';

export const getListParams = (params: any) => qs.stringify({
  filter: {
    state: 'online,offline,deactivated,payment_required,draft,outdated',
    ...params.filter
  },
  fields: {
    work_types: 'name',
    entry_levels: 'name',
    branches: 'city,region',
    companies: 'name',
    categories: 'name',
    job_providers: 'title'
  },
  include: 'work_type,entry_level,branch,company,job_provider,category',
  page: {
    ...params.page
  },
  sort: params.sort
});

const oneParams = () => qs.stringify({
  include: 'work_type,entry_level,branches,category,recruiter,regions,places,studies,company.logo_image_item,company.header_image_item,job_provider,job_language,header_image_item',
  fields: {
    work_types: 'id,name',
    entry_levels: 'id,name',
    branches: 'id,name,address,zip,city,region',
    regions: 'id,name',
    categories: 'id,name',
    recruiter: 'id'
  }
});

class JobsApi extends Api {
  serializerType = 'jobs';

  serializerOptions = {
    attributes: [
      'title', 'desc', 'state', 'about', 'jobLanguage',
      'workType', 'studies', 'category', 'entryLevel', 'branch', 'branches', 'region', 'regions', 'place', 'places',
      'startsAt', 'startsAtFormat', 'applicationDeadline', 'applicationMethod', 'applicationTarget', 'applicationText',
      'company', 'jobProviderId', 'oauthApplicationId', 'external', 'content', 'manuallyEditable', 'expiryDateFromAdmin'
    ],
    jobLanguage: { ref: 'id' },
    workType: { ref: 'id' },
    studies: { ref: 'id' },
    category: { ref: 'id' },
    entryLevel: { ref: 'id' },
    branch: { ref: 'id' },
    branches: { ref: 'id' },
    region: { ref: 'id' },
    regions: { ref: 'id' },
    place: { ref: 'id' },
    places: { ref: 'id' },
    company: { ref: 'id' },
    jobProviderId: { ref: 'id' },
    oauthApplicationId: { ref: 'id' },
    typeForAttribute: (type: string) => {
      switch (type) {
      case 'jobLanguage': return 'job_languages';
      case 'workType': return 'work_types';
      case 'entryLevel': return 'entry_levels';
      case 'jobProviderId': return 'job_providers';
      default: return undefined;
      }
    }
  };

  fetch = async (params: {} = {}) => {
    const json = await this.request(`jobs?${getListParams(params)}`);
    const data = await this.deserialize(json);

    return { data, meta: json.meta };
  }

  get = async (id: number | string) => {
    const json = await this.request(`jobs/${id}?${oneParams()}`);
    const data = await this.deserialize(json);

    return data;
  }

  create = async (job: {}) => {
    const body = await this.serialize(job);
    const json = await this.request(`jobs?${oneParams()}`, { body: JSON.stringify(body), method: 'POST' });
    const data = await this.deserialize(json);

    return data;
  }

  update = async (id: number | string, job: {}) => {
    const body = await this.serialize({ id, ...job });
    const json = await this.request(`jobs/${id}?${oneParams()}`, { body: JSON.stringify(body), method: 'PATCH' });
    const data = await this.deserialize(json);

    return data;
  }

  destroy = async (id: number | string) => {
    await this.request(`jobs/${id}`, { method: 'DELETE' });
  }

  languages = async () => {
    const json = await this.request('job_languages');
    const data = await this.deserialize(json);

    return { data };
  }
}

export default new JobsApi();
